const CART_KEY = "public_shop_cart_v1";
const RESUME_KEY = "resume_shop_after_auth_v1";
const CHECKOUT_INTENT_KEY = "public_shop_checkout_intent_v1";

export function saveCheckoutIntent(intent) {
  try {
    sessionStorage.setItem(
      CHECKOUT_INTENT_KEY,
      JSON.stringify(intent || null)
    );
  } catch (e) {
    console.warn("saveCheckoutIntent failed:", e);
  }
}

export function loadCheckoutIntent() {
  try {
    const raw = sessionStorage.getItem(CHECKOUT_INTENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    console.warn("loadCheckoutIntent failed:", e);
    return null;
  }
}

export function clearCheckoutIntent() {
  try {
    sessionStorage.removeItem(CHECKOUT_INTENT_KEY);
  } catch (e) {
    console.warn("clearCheckoutIntent failed:", e);
  }
}

export function savePublicShopCart(cart) {
  try {
    sessionStorage.setItem(CART_KEY, JSON.stringify(cart || {}));
  } catch (e) {
    console.warn("savePublicShopCart failed:", e);
  }
}

export function loadPublicShopCart() {
  try {
    const raw = sessionStorage.getItem(CART_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (e) {
    console.warn("loadPublicShopCart failed:", e);
    return {};
  }
}

export function clearPublicShopCart() {
  try {
    sessionStorage.removeItem(CART_KEY);
  } catch (e) {
    console.warn("clearPublicShopCart failed:", e);
  }
}

export function setResumeShopAfterAuth(value = true) {
  try {
    if (value) {
      sessionStorage.setItem(RESUME_KEY, "1");
    } else {
      sessionStorage.removeItem(RESUME_KEY);
    }
  } catch (e) {
    console.warn("setResumeShopAfterAuth failed:", e);
  }
}

export function consumeResumeShopAfterAuth() {
  try {
    const v = sessionStorage.getItem(RESUME_KEY) === "1";
    sessionStorage.removeItem(RESUME_KEY);
    return v;
  } catch (e) {
    console.warn("consumeResumeShopAfterAuth failed:", e);
    return false;
  }
}